// Braden Scale section questionnaire constants
export enum BradenScaleQuestionnaireItem {
  BRADEN_SCALE_SENSORY_QUESTION = 'braden-scale/sensory/question',
  BRADEN_SCALE_SENSORY_NOTES = 'braden-scale/sensory/notes',
  BRADEN_SCALE_MOISTURE_QUESTION = 'braden-scale/moisture/question',
  BRADEN_SCALE_MOISTURE_NOTES = 'braden-scale/moisture/notes',
  BRADEN_SCALE_ACTIVITY_QUESTION = 'braden-scale/activity/question',
  BRADEN_SCALE_ACTIVITY_NOTES = 'braden-scale/activity/notes',
  BRADEN_SCALE_MOBILITY_QUESTION = 'braden-scale/mobility/question',
  BRADEN_SCALE_MOBILITY_NOTES = 'braden-scale/mobility/notes',
  BRADEN_SCALE_NUTRITION_QUESTION = 'braden-scale/nutrition/question',
  BRADEN_SCALE_NUTRITION_NOTES = 'braden-scale/nutrition/notes',
  BRADEN_SCALE_FRICTION_AND_SHEAR_QUESTION = 'braden-scale/friction-and-shear/question',
  BRADEN_SCALE_FRICTION_AND_SHEAR_NOTES = 'braden-scale/friction-and-shear/notes'
}
